import React from 'react';
import { CheckIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/1sP3fzjSBG7prdfNmkVzmQ/BONO_1_(4).png',
  title: 'Bono 1 – Guía Rápida de Rutinas Montessori',
  features: ['Rutinas diarias y semanales', 'Transiciones sin conflicto', 'Plantillas listas para usar'],
  originalValue: '$19.990 ARS'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/3soHPoeJw3xW19z5tCAobs/BONO_2_(3).png',
  title: 'Bono 2 – Banco de Frases Montessori',
  features: ['Frases para acompañar emociones', 'Límites con respeto', 'Tarjetas imprimibles'],
  originalValue: '$14.990 ARS'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/dTDK8HpVPqdbf1DfePeH46/BONO_3_(3).png',
  title: 'Bono 3 – Mini Guía de Primeros Auxilios Emocionales',
  features: ['Qué hacer en berrinches', 'Qué evitar', 'Cómo reparar el vínculo'],
  originalValue: '$14.990 ARS'
}];
export function BonusSection() {
  return <section className="w-full bg-[#F5EDE4] py-16 px-4" data-id="element-44">
      <div className="max-w-5xl mx-auto" data-id="element-45">
        <div className="text-center mb-12" data-id="element-46">
          <span className="text-4xl mb-4 block" data-id="element-47">🎁</span>
          <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-2" data-id="element-48">
            BONOS EXCLUSIVOS
          </h2>
          <p className="text-xl font-bold text-[#C4645A] bg-[#FDE8E4] inline-block px-4 py-1 rounded-full mb-4" data-id="element-49">
            ⚠️ GRATIS SOLO POR HOY ⚠️
          </p>
          <p className="text-[#8B7355] max-w-2xl mx-auto" data-id="element-50">
            Estos bonos no siempre están incluidos. Hoy los recibís SIN COSTO
            adicional.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-51">
          {bonuses.map((bonus, index) => <a key={index} href={CHECKOUT_URL} className="bg-[#FDF8F3] rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group flex flex-col" data-id="element-52">
              {/* Image Container */}
              <div className="relative w-full aspect-square bg-[#F5EDE4]" data-id="element-53">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform" data-id="element-54" />
                {/* GRATIS Badge */}
                <div className="absolute top-4 left-4 bg-[#D4956A] text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-55">
                  GRATIS HOY
                </div>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-56">
                {/* Price */}
                <div className="flex items-center gap-2 mb-3" data-id="element-57">
                  <span className="text-[#8B7355]/60 line-through text-sm" data-id="element-58">
                    Valor: {bonus.originalValue}
                  </span>
                  <span className="text-[#8B9E7E] font-bold text-sm" data-id="element-59">
                    HOY: GRATIS
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-[#5C4033] mb-4" data-id="element-60">
                  🎁 {bonus.title}
                </h3>

                {/* Features Checklist */}
                <ul className="space-y-2 mt-auto" data-id="element-61">
                  {bonus.features.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-62">
                      <CheckIcon className="w-4 h-4 text-[#8B9E7E] mt-1 flex-shrink-0" data-id="element-63" />
                      <span className="text-[#8B7355] text-sm" data-id="element-64">{feature}</span>
                    </li>)}
                </ul>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}